import { IUserDto } from "./UserDto";

export interface IUsersDto {
    users: IUserDto[] | undefined;
}

export class UsersDto implements IUsersDto {
    public users: IUserDto[];

    constructor(){
        this.users = new Array<IUserDto>();
    }
}